'use client';
import { useState } from 'react';

import CloseIcon from '@/fo/icons/base/icons/close.svg';
import LogoIcon from '@/fo/icons/base/icons/logo.svg';
import SearchIcon from '@/fo/icons/base/icons/search.svg';
import { searchActions } from '@/fo/store/search-suggestion';
import { MenuItem } from '@/fo/ui/app/menu/base';

import { FirstScreen } from '../components/FirstScreen/FirstScreen';

import { styles } from './UiAppMenuMobile.styles';

export interface UiAppMenuMobileProps {
  className?: string;
  items?: MenuItem[];
  customVariables?: {
    [key: string]: string | unknown[];
  };
  searchSuggestion?: React.ReactNode;
}

export function UiAppMenuMobile({
  className,
  items = [],
  closeMenu,
  customVariables,
  searchSuggestion
}: UiAppMenuMobileProps & { closeMenu: () => void }) {
  const slots = styles();
  const [showSearch, setShowSearch] = useState(false);

  const handleShowSearch = () => {
    setShowSearch(true);
    searchActions.fillDefaultData();
  };

  if (showSearch) {
    return (
      <div className={slots.base({ className })}>
        <div className={slots.main()}>
          <div
            className={slots.close()}
            onClick={() => setShowSearch(false)}
          >
            <CloseIcon className={slots.closeIcon()} />
          </div>
          <div className={slots.logo()}>
            <LogoIcon className={slots.logoIcon()} />
          </div>
          <div className={slots.search()}>
            <SearchIcon className={slots.searchIcon()} />
          </div>
        </div>
        {searchSuggestion}
      </div>
    );
  }

  return (
    <div className={slots.base({ className })}>
      <FirstScreen
        items={items}
        onMenuClose={closeMenu}
        customVariables={customVariables}
        onSearchClick={() => handleShowSearch()}
      />
    </div>
  );
}
